import { render, staticRenderFns } from "./stepSaldoCartoes.vue?vue&type=template&id=3030d779"
import script from "./stepSaldoCartoes.vue?vue&type=script&lang=ts"
export * from "./stepSaldoCartoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports